import { Grid, Typography } from '@mui/material';
import { type FC, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router';

import CloudResetPassword from './CloudPasswordReset';

import useSeeChangeCloudPwd from '@/components/AppLayout/hooks/useSeeChangeCloudPwd';

const Settings: FC = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const canSeeChangeCloudPwd: boolean = useSeeChangeCloudPwd();

  useEffect(() => {
    if (!canSeeChangeCloudPwd) {
      navigate(-1);
    }
  }, [canSeeChangeCloudPwd, navigate]);

  if (!canSeeChangeCloudPwd) {
    return null;
  }

  return (
    <Grid
      container
      marginTop={3}
      justifyContent='space-between'
      rowGap={2}
      justifySelf={'center'}
      maxWidth={1000}
    >
      <Grid
        item
        xs={8}
      >
        <Typography
          variant='h4'
          color='primary'
        >
          {intl.formatMessage({ id: 'cloudPassword' })}
        </Typography>
        <Typography variant='h6'>{intl.formatMessage({ id: 'changeCloudPassword' })}</Typography>
      </Grid>
      <Grid
        item
        xs={4}
      >
        <CloudResetPassword />
      </Grid>
    </Grid>
  );
};

export default Settings;
